import { Dialog, DialogContent, DialogTitle } from '@dls/react-core';
import React from 'react';
import { ColorDLS } from '../../styling/color';
import { SubjectForm } from '../subjects/subject-form';
import { createSubject, Subject } from '../../api/studykit';
import { useSnackbar } from 'notistack';
import { NotiStackAction } from '../styled/notistack-action';
import { StyledBlueHeading } from '../styled/styles';
import { AsyncSubmitHandler } from '../../helpers/form-error-handling';

interface DialogProps {
  open: boolean;
  onClose: () => void;
  studyId: string;
  onSubjectCreated: (subject: Subject) => Promise<void>;
}

export const CreateSubjectDialog: React.FC<DialogProps> = ({
  open,
  onClose,
  studyId,
  onSubjectCreated,
}) => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const onSubmit: AsyncSubmitHandler<Subject> = async (data, event) => {
    await createSubject(studyId!, data)
      .then(onSubjectCreated)
      .then(() => {
        enqueueSnackbar(`${data.name} has successfully been added!`, {
          variant: 'success',
          action: <NotiStackAction close={closeSnackbar} />,
        });
        onClose();
      })
      .catch((err: Error) => {
        console.log(err);
        enqueueSnackbar(err.message, {
          variant: 'error',
          action: <NotiStackAction close={closeSnackbar} />,
        });
      });
    event?.preventDefault();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle disableTypography>
        <StyledBlueHeading variant="h2" style={{ color: ColorDLS.Blue45, fontWeight: 400 }}>
          Subject details
        </StyledBlueHeading>
      </DialogTitle>
      <DialogContent>
        <SubjectForm onSubmit={onSubmit} onCancel={onClose} />
      </DialogContent>
    </Dialog>
  );
};
